{
  "conversation": {
    "agent_mode": {
      "saved": "Valgt profil",
      "agents": {
        "kaila": {
          "name": "KAILA Jura",
          "description": "Juridisk assistent"
        },
        "kfc": {
          "name": "KAILA Kommune",
          "description": "Denne samtalen er basert på saksbehandlerprofilen. Her brukes kommunens opplastede dokumenter i svaret."
        },
        "replay": {
          "name": "Gjenavspilling",
          "description": "Spill av tidligere samtaler"
        },
        "mock": {
          "name": "Mock",
          "description": "Simulert agent"
        }
      }
    },
    "ask_kaila_back": {
      "submit_button": "Svar",
      "user_selected": "Jeg har valgt følgende muligheter:",
      "mode_question": "Spørsmål",
      "mode_suggestion": "Forslag",
      "switch_mode": "Kjør grundig forskning",
      "keep_previous_mode": "Behold {{previous}}svaret",
      "about_deep": "Grundig research kan gi deg et mer fullstendig svar",
      "deep_description": "Grundig research sjekker lovgivning, rettspraksis og relaterte kilder før du svarer, slik at du kan få mer kontekst og flere referanser.",
      "kfc_title": "Hvilke områder bør jeg fokusere på?",
      "kfc_description": "Jeg har identifisert følgende områder som kan være relevante for spørsmålet ditt. Velg alle som er aktuelle.",
      "skip": "Hopp over"
    },
    "references_panel": {
      "empty_state": "Ingen kilder til dette svaret.",
      "source_validation": {
        "button": "Vis",
        "toggle_type": "rype",
        "toggle_name": "rittel"
      },
      "error": {
        "title": "Det oppstod en feil",
        "description": "Det oppstod en feil under innlasting av kilder"
      },
      "go_to_document": "Gå til dokument",
      "header": "Kilder",
      "no_content_disclaimer": "Forhåndsvisning er ikke tilgjengelig",
      "open_in_karnov": "Åpne i Lovdata Pro Karnov",
      "ai_generated_summary": {
        "text": "Sammendrag fra KAILA",
        "tooltip": "Rettpraksis sammenfattes av AI for å gi et raskt overblikk."
      }
    },
    "annotation_type": {
      "karnov": "Karnovs noter",
      "lexino": "",
      "nj_annotation": ""
    },
    "conversation_error": {
      "title": "Noe gikk galt",
      "description": "Noe gikk galt med samtalen. Prøv å laste inn siden på nytt eller kontakt kundeservice.",
      "guide": "Hjelp oss å feilsøke problemet ved å dele innholdet i samtalen.",
      "send_to_support": "Del samtalen med oss",
      "success_title": "Feilrapport sendt",
      "success_message": "Takk, feilrapporten din er sendt"
    },
    "conversation_feedback": {
      "cancel": "Hopp over",
      "confirmation": "Takk for at du deler tilbakemeldingen din",
      "conversation_rating_question": "Begrunn vurderingen din",
      "description": "Velg den kategorien som passer best til tilbakemeldingen din. Detaljert tilbakemelding gjør det mulig å forbedre KAILAs svar fremover. Når du sender inn tilbakemelding, samtykker du til at vi kan se tilbakemeldingen din, hele samtalen (spørsmål og svar), eventuelle kilder og vedlegg.",
      "error": "Noe gikk galt, prøv gjerne igjen",
      "feedback_modal": "Vi vil gjerne ha din tilbakemelding",
      "consent_checkbox": "Jeg samtykker til å bli kontaktet dersom det er behov for ytterligere opplysninger.",
      "options": {
        "1": {
          "title": "Historiske rettskilder",
          "placeholder": "Svaret er basert på opphevede rettskilder"
        },
        "2": {
          "title": "Hallusinasjoner",
          "placeholder": "Svaret inneholder oppdiktede referanser eller konklusjoner uten gyldige rettskilder til å støtte svaret"
        },
        "3": {
          "title": "Manglende rettskilder",
          "placeholder": "Svaret mangler referanser til relevante rettskilder. Angi gjerne den/de manglende rettskilden(e)"
        },
        "4": {
          "title": "Feil bruk av juridisk metode",
          "placeholder": "Feiltolkning av rettskilder"
        },
        "5": {
          "title": "Foreldet informasjon",
          "placeholder": "Svaret tok ikke hensyn til de nyeste rettskildene"
        },
        "6": {
          "title": "Annet",
          "placeholder": "Opplevde du andre problemer med svaret? Gi oss beskjed"
        }
      },
      "submit": "Send tilbakemelding",
      "textarea_placeholder": "Utdyp gjerne ...",
      "title": "Takk for at du deler tilbakemeldingen din"
    },
    "conversation_sources": "Kilder",
    "prompt_templates": {
      "create_title": "Lagre ny prompt",
      "create_description": "Lagre prompts til senere bruk. Det kan være nyttig for oppgaver eller spørsmål du ofte gjentar eller starter på samme måte.",
      "edit_title": "Rediger prompt",
      "title_label": "Tittel",
      "title_placeholder": "",
      "content_label": "Din prompt",
      "content_placeholder": "",
      "save": "Lagre",
      "cancel": "Avbryt",
      "delete": "Slett",
      "save_success": "Prompt lagret",
      "save_error": "Prompten kunne ikke lagres",
      "validation_error": "Kontroller tittel og prompt, og prøv igjen",
      "delete_success": "Prompt slettet",
      "delete_error": "Prompten kunne ikke slettes",
      "delete_confirm": {
        "title": "Slett prompt",
        "question": "Er du sikker på at du vil slette prompten?",
        "confirm": "Slett",
        "cancel": "Avbryt"
      },
      "title": "Lagrede spørsmål",
      "description": "Et spørsmål er det du spør KAILA om. Lagre spørsmål du bruker ofte, og bruk dem på nytt med en gang — perfekt for gjentakende oppgaver og arbeidsflyter du regelmessig kommer tilbake til.",
      "new_prompt": "Ny prompt",
      "search_placeholder": "Søk blant prompts...",
      "search_aria": "Søk blant lagrede prompts",
      "search_clear": "Tøm søk",
      "see_details": "Vis detaljer",
      "close_details": "Skjul detaljer",
      "edit": "Rediger",
      "edit_prompt_aria": "Rediger prompt: {{title}}",
      "trigger_label": "Prompt",
      "trigger_tooltip": "Åpne lagrede prompter",
      "no_results": "Ingen resultater",
      "close": "Lukk lagrede prompter",
      "delete_prompt_aria": "Slett prompt: {{title}}",
      "error": {
        "title": "Det oppstod en feil",
        "description": "Det oppstod en feil da lagrede prompter skulle lastes inn"
      },
      "pagination": "Sideinndeling",
      "pagination_previous": "Forrige",
      "pagination_next": "Neste",
      "pagination_previous_aria": "Gå til forrige side",
      "pagination_next_aria": "Gå til neste side",
      "pagination_page_aria": "Gå til side {{page}}",
      "attachment_warning": "Opplasting og merker støttes ennå ikke for lagrede ledetekster.",
      "suggest": "Foreslå",
      "generating_title": "Genererer tittel",
      "title_error": "Kunne ikke generere en tittel."
    },
    "message_done_toast": "Samtalen din er ferdig. Klikk her for å gå til samtalen",
    "message_done_toast_with_subject": "Samtalen din \"{{subject}}\" er ferdig. Klikk her for å gå til samtalen",
    "error": {
      "no_access": {
        "description": "Velg en annen samtale eller start en ny samtale i menyen",
        "title": "Du har ikke tilgang til denne samtalen"
      },
      "not_found": {
        "description": "Velg en annen samtale eller start en ny samtale i menyen",
        "title": "Samtale ikke funnet"
      },
      "unknown": {
        "description": "Prøv å laste inn siden på nytt",
        "title": "Samtalen din kan ikke hentes for øyeblikket"
      }
    },
    "message_action": {
      "cancel_edit_message": "Avbryt redigering",
      "copy_message": "Kopier",
      "delete_failed_user_message": "Slett",
      "downvote_message": "Ikke liker",
      "upvote_message": "Liker",
      "edit_message": "Rediger prompt",
      "edit": "Rediger",
      "export_docx": "Eksporter til Word",
      "export": "Eksporter",
      "more_actions": "Flere handlinger",
      "print_message": "Skriv ut",
      "regenerate_message": "Generer svar på nytt",
      "save_message": "Lagre prompt",
      "save": "Lagre",
      "skip_to_content": "Gå til toppen av meldingen",
      "to_top": "Til toppen"
    },
    "export_docx": {
      "success": "Dokument eksportert",
      "error": "Kunne ikke eksportere dokument",
      "question_heading": "Spørsmål",
      "answer_heading": "Svar"
    },
    "prompt_input": {
      "disclaimer_text": "Vår AI bruker kilder fra Karnovs database, men kan gjøre feil. Dobbeltsjekk derfor viktige opplysninger.",
      "disclaimer_link": {
        "prefix": "",
        "text": "",
        "suffix": "",
        "href": ""
      },
      "placeholder": "Skriv spørsmålet ditt",
      "placeholder_follow_up": "Skriv et oppfølgingsspørsmål",
      "document_tag": "Henvis til dokument"
    },
    "document_tagging": {
      "placeholder": "Skriv dokumentets navn her",
      "prompt_input_suggestion": "Henvis til dokument",
      "clear_input": "Tøm søketekst",
      "finding_documents": "Henter dokumenter ...",
      "search_for_documents_title": "Søk etter et dokument fra Lovdata Pro Karnov",
      "search_for_documents_description": "Oppgi dokumentets tittel eller referansenummer",
      "no_documents_found_title": "Fant ingen dokumenter",
      "no_documents_found_description": "Skriv en gyldig tittel eller referanse, eller gå til Lovdata Pro Karnov og finn dokumentet.",
      "kfc_disclaimer": "Kaila har allerede tilgang til dine lokale dokumenter, så de trenger ikke å tagges.",
      "error_title": "Noe gikk galt",
      "error_description": "Prøv å laste inn siden på nytt",
      "title": "Søkeresultater"
    },
    "prompt_button": {
      "label": "Spør Kaila",
      "stop": "Avbryt"
    },
    "research_mode": {
      "light": {
        "name": "Enkelt søk",
        "short": "Enkelt",
        "description": "For raske spørsmål. Henter et begrenset utvalg kilder; ingen fullstendig gjennomgang."
      },
      "regular": {
        "name": "Vanlig søk",
        "short": "Vanlig",
        "description": "Søker gjennom alle Karnovs kilder og utarbeider et strukturert svar."
      },
      "deep": {
        "name": "Dyptgående søk",
        "short": "Dyptgående",
        "description": "Utfører et omfattende søk for komplekse spørsmål. Tar lengre tid."
      }
    },
    "user_message": {
      "cancel_button": "Avbryt",
      "submit_button": "Lagre og send"
    },
    "table_view": {
      "close_button": "Lukk tabell i full størrelse",
      "modal_title": "Tabell i full størrelse",
      "open_button": "Åpne i full størrelse"
    },
    "loading_header": {
      "estimated_time": "Estimert ventetid",
      "less_than_a_minute": "Mindre enn ett minutt",
      "minutes_one": "{{count}} minutt",
      "minutes_other": "{{count}} minutter",
      "slow_answer_disclaimer": "Genererer et komplekst svar. Dette kan ta litt ekstra tid."
    },
    "clipboard": {
      "copy_success": "Innhold kopiert",
      "copy_error": "Kopiering av innhold mislyktes"
    }
  },
  "conversation_history": {
    "load_more_button": "Last inn flere",
    "load_more_title": "Viser side {{currentPage}} av {{totalPages}}",
    "no_more_conversations": "Du har nådd slutten av samtalehistorikken din.",
    "go_to_top": "Gå til toppen av listen",
    "close_conversation_history_panel": "Skjul historikk",
    "close_conversation_sidepanel": "Lukk sidepanel",
    "conversation_expiration_one": "{{count}} dag",
    "conversation_expiration_other": "{{count}} dager",
    "conversation_expiration_tooltip_one": "Utløper om 1 dag. Fest eller send en ny melding for å beholde samtalene dine.",
    "conversation_expiration_tooltip_other": "Utløper om {{count}} dager. Fest eller send en ny melding for å beholde samtalene dine.",
    "conversation_expiration_expired_tooltip": "Samtalene dine lagres i 90 dager etter siste aktivitet. Deretter slettes de automatisk.",
    "conversation_action": {
      "delete": "Slett samtale",
      "pin": "Fest",
      "rename": "Gi nytt navn",
      "unpin": "Fjern festing"
    },
    "conversation_delete_modal": {
      "cancel_button": "Avbryt",
      "delete_button": "Slett",
      "title": "Slett samtale",
      "question": "Er du sikker på at du vil slette samtalen"
    },
    "error": {
      "description": "Prøv å laste inn siden på nytt",
      "title": "Historikken din kan ikke hentes for øyeblikket"
    },
    "expired_conversations_onboarding": "For å beskytte dataene dine vil samtaler som har vært inaktive i mer enn 90 dager nå bli permanent slettet.",
    "history": "Historikk",
    "history_expiration_time": "90 dager",
    "history_short": "Historikk",
    "history_tooltip": "Samtalene dine lagres i 90 dager etter siste aktivitet. Deretter slettes de automatisk.",
    "new_conversation_button": "Ny samtale",
    "new_conversation_button_short": "Ny",
    "new_conversation_subject": "Ny samtale",
    "new_document_analysis_button": "KAILA Dokumentanalyse",
    "new_document_analysis_button_beta_label": "BETA",
    "new_document_analysis_button_new_label": "Nyhet",
    "new_document_analysis_button_short": "Analyse",
    "flow_access_link": "KAILA Flow",
    "flow_access_link_short": "Flow",
    "open_conversation_history_panel": "Vis historikk",
    "open_conversation_sidepanel": "Åpne sidepanel",
    "panel_header": "Meny",
    "pinned": "Festet",
    "edit_conversation_subject_submit": "Lagre endringene i samtaleemnet",
    "edit_conversation_subject_cancel": "Avbryt endringene i samtaleemnet",
    "search_in_conversation": "Finn samtale",
    "search_in_conversation_description": "Søk i samtaler etter emne",
    "search_in_conversation_clear": "Tøm søk",
    "empty_search_in_conversation": "Ingen samtaler ble funnet med søket: \"{{searchTerm}}\"",
    "toast_notification": {
      "conversation_pinned_error": "Festing av samtale mislyktes",
      "conversation_unpinned_error": "Fjerning av festing mislyktes",
      "conversation_pinned_successful": "Samtale festet",
      "conversation_unpinned_successful": "Samtale ikke lenger festet",
      "conversation_delete_success": "Samtale slettet",
      "conversation_delete_error": "Samtalen ble ikke slettet",
      "subject_editting_error": "Endringer kunne ikke gjennomføres",
      "subject_editting_sucessful": "Endringer gjennomført"
    },
    "today": "I dag",
    "yesterday": "I går",
    "latest_7_days": "Siste 7 dager",
    "latest_15_days": "Siste 15 dager",
    "latest_30_days": "Siste 30 dager",
    "latest_60_days": "Siste 60 dager",
    "more_than_60_days": "Over 60 dager – utløper snart",
    "expired": "Utløper snart",
    "retention_info": "Dine aktive samtaler lagres i 90 dager. Deretter slettes de automatisk for å beskytte personvernet ditt."
  },
  "file_upload": {
    "capacity_usage": "{{space}}% plass brukt",
    "content_type": {
      "application/pdf": "PDF",
      "application/msword": "Word",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
      "unknown": "Ukjent",
      "unsupported": "Filtype ikke støttet"
    },
    "drag_and_drop_label_one": "Dra og slipp dokumentet ditt her",
    "drag_and_drop_label_other": "Dra og slipp dokumentene dine her",
    "file_upload_limit_exceeded": "Du har valgt for mange filer.",
    "file_upload_limit_reached": "Du kan ikke laste opp flere dokumenter.",
    "header": "Last opp dokumentet ditt for å komme i gang",
    "subheader": "Kan være Word (.docx) eller PDF",
    "upload_button": "Last opp dokument",
    "upload_status": {
      "error": "Feil",
      "uploading": "Laster opp",
      "deleting": "Sletter"
    },
    "error": {
      "above_page_count_limit": "Filene kan ikke inneholde mer enn 400 sider.",
      "above_word_count_limit": "Filene kan ikke inneholde mer enn 100 000 ord",
      "above_file_size_limit": "Filene kan ikke være større enn 20 MB.",
      "content_too_large": "Filene kan ikke være større enn 20 MB.",
      "malformed_file_content": "Filen kunne ikke leses – den ser ut til å være skadet",
      "deletion_error": "Det oppstod en feil under sletting av filen.",
      "invalid_mime_type": "Du kan bare laste opp Word- (.docx) og PDF-filer.",
      "exceeds_token_limit": "Dette dokument overskrider plassgrensen og vil ikke bli brukt.",
      "upload_error": "Det oppstod en feil under opplasting.",
      "virus_detected": "Den opplastede filen ser ut til å inneholde et virus."
    }
  },
  "frequently_asked_questions": {
    "footer": {
      "customer_service": "Kundeservice",
      "customer_service_url": "https://www.karnovgroup.dk/om-os/kontakt",
      "terms": "Brukervilkår",
      "terms_url": "https://pro.karnovgroup.dk/tos_acceptance"
    },
    "help": "Hjelp",
    "helpful_question_answer_title": "Besvarte dette spørsmålet ditt?",
    "helpful_question_answer_button_yes": "Ja",
    "helpful_question_answer_button_no": "Nei",
    "thank_you_for_feedback_description": "Innspillet ditt hjelper med å forbedre denne informasjonen for alle.",
    "thank_you_for_feedback_title": "Takk for tilbakemeldingen!",
    "thank_you_for_feedback_toast_notification": "Takk for tilbakemeldingen",
    "related_questions": "Relaterte spørsmål"
  },
  "help_and_feedback": {
    "button": "Hjelp og tilbakemelding",
    "dropdown_options": {
      "help": "Hjelp",
      "tutorial": "Veiledning",
      "user_carousel_onboarding": "Onboarding"
    }
  },
  "kfc": {
    "description": "Det første svaret er basert på kilder i Karnovs database, mens dette supplerende svaret bygger på kommunens interne dokumenter, under forutsetning av at disse er lastet opp og tilgjengelige i Karnov Kommune. Begge svar inkluderer referanser og lenker til kildene de bygger på."
  },
  "message": {
    "create_conversation_message_error": "Kunne ikke sende.",
    "create_conversation_message_retry": "Prøv igjen",
    "streaming_waiting": "Avventer svar",
    "streaming_canceled": "Svar stoppet",
    "streaming_error": "Det oppstod en feil under generering av svaret",
    "streaming_error_retry": "Generer igjen",
    "streaming_error_code": "Feilkode",
    "streaming_error_conversation": "Samtale",
    "streaming_reconnect_error": "Det oppstod en feil under forsøk på å gjenopprette tilkoblingen",
    "streaming_reconnect_error_retry": "Forsøk å gjenopprette tilkoblingen",
    "thoughts": "Refleksjoner",
    "follow_up": "Du kan også spørre",
    "follow_up_description": "Forslagene til oppfølgingsprompt hjelper deg videre i samtalen. Du kan velge et av forslagene og tilpasse dem til din konkrete situasjon ved å gi mer kontekst, styre eller utvide samtalen.",
    "updated_at": "{{updatedAt, date}}"
  },
  "no_access": {
    "title": "Du har ikke tilgang til dette innholdet",
    "description": "Dette innholdet krever tilgang til et produkt som ikke er inkludert i det nåværende abonnementet ditt.",
    "refresh_access": {
      "button": "Oppdater tilgang",
      "description": "Hvis du mener at det er en feil, kan du prøve å oppdatere tilgangsinnstillingene dine – det vil synkronisere abonnementet ditt og låse opp det innholdet du har tilgang til.",
      "contact_support": "Hvis problemet fortsetter, bes du kontakte kundeservice."
    },
    "contact_info": {
      "header": "Vi er klare til å hjelpe",
      "description": "Ring eller skriv til vår kundeservice og hør om ulike lisenser",
      "link": {
        "prefix": "",
        "text": "",
        "suffix": "",
        "href": ""
      },
      "phone": "+45 33 74 07 00",
      "email": "kundeservice@karnovgroup.com"
    }
  },
  "system_messages": {
    "_ANALYSING_DOCUMENTS_": "Analyserer dokumenter",
    "_ANALYSING_QUERY_": "Analyserer spørsmålet",
    "_ANALYSING_SOURCES_": "Analyserer kilder",
    "_FETCHING_SIMILAR_DOCUMENTS_": "Søker etter kilder",
    "_FETCHING_LAW_DOCUMENTS_": "Søker etter lovreferanser",
    "_FETCHING_PREPATORY_WORK_DOCUMENTS_": "Søker etter forarbeider",
    "_FETCHING_LITERATURE_DOCUMENTS_": "Søker etter litteraturreferanser",
    "_GENERATING_ANSWER_": "Genererer et svar"
  },
  "document_tag_tooltip": "Klikk eller skriv ”@” for å henvise til et dokument",
  "input_character_limit_reached": "Maksimalt antall tegn er nådd",
  "user_carousels": {
    "dismiss": "Fortsett",
    "carousels": {
      "onboarding": {
        "title": "Velkommen til KAILA",
        "read_more_url": "",
        "screens": {
          "welcome": {
            "description": "Kombinasjonen av hverdagsspråk og Karnovs AI-modell gjør det enklere å søke etter juridisk informasjon",
            "header": "Finn svar på dine juridiske spørsmål"
          },
          "credibility": {
            "description": "Den menneskelige kunnskapen forsterker AI-teknologien, og du vil alltid ha det siste ordet",
            "header": "Basert på Karnovs innhold"
          },
          "security": {
            "description": "KAILA sikrer dataene dine gjennom streng datastyring",
            "header": "Dataene dine tas godt vare på"
          },
          "feedback": {
            "description": "Vurder de genererte svarene og fortell oss hva vi kan forbedre",
            "header": "Hjelp oss å forbedre KAILA med tilbakemeldingene dine"
          }
        }
      }
    },
    "read_more_label": "Les mer"
  },
  "header": {
    "goto_main_content": "Gå til innholdet"
  },
  "user_menu": {
    "logout": "Logg ut",
    "go_to_platform": "Lovdata Pro Karnov",
    "redirect_to_login": "Oppdater tilgang",
    "theme_selector": {
      "appearance": "Utseende",
      "theme": {
        "dark": "Mørk",
        "light": "Lys",
        "system": "System"
      }
    },
    "language_selector": {
      "content": "innhold",
      "header": "Språk",
      "languages": {
        "da": "Dansk",
        "es": "Spansk",
        "fr": "Fransk",
        "sv": "Svensk",
        "no": "Bokmål",
        "nn": "Nynorsk"
      }
    },
    "go_to_flow": "KAILA Flow",
    "learn_about_flow": "Lær mer om vår nye løsning",
    "badge": "Nyhet"
  },
  "platform_name": "KAILA",
  "document_analysis": {
    "select_document_analysis_mode": "Velg en analysemulighet",
    "hero_banner": {
      "intro": "Karnov introduserer",
      "headline": "KAILA dokumentanalyse",
      "description": "Våre eksperter har utviklet unike analysemuligheter som hjelper deg med å omsette komplisert juss til konkrete løsninger."
    },
    "file_upload_header": {
      "description": "Last opp kontrakten din for å komme i gang",
      "title": "Kontraktsgjennomgang"
    },
    "use_prompt_button": "Velg analyse",
    "see_example_button": "Se eksempel",
    "back_to_document_analysis_list": "Tilbake til dokumentanalyser",
    "options": {
      "contract_review": {
        "title": "Analyser kontrakter",
        "description": "Få en rask, klausul-for-klausul gjennomgang av kontrakten din. For hver klausul henter KAILA de viktigste kildene, markerer mulige risikoer, vurderer risikonivå – høy, middels, lav – og foreslår konkrete forbedringer. Du får en oversiktlig vurdering av hele kontrakten, med klare anbefalinger og dokumenterte kilder.",
        "guide": "I tillegg til det opplastede dokumentet kan du legge til supplerende opplysninger, f.eks. kontraktstype og part, samt andre relevante omstendigheter som ikke fremgår av dokumentet.",
        "example_text": "Her ser du et eksempel på en analyse. Det gir overblikk over KAILAs svar, slik at du kan vurdere om det passer til dine behov.",
        "placeholder": "Legg til supplerende opplysninger"
      },
      "document_compliance": {
        "title": "Analyser compliance-politikk",
        "description": "Analyser og sammenhold compliance-politikken din med relevante rettskilder. KAILA leverer en rapport i tre deler: et kort sammendrag, en oversiktstabell med risikovurdering og en liste med tydelige løsningsforslag. Du får et komplett overblikk, slik at du vet hva neste steg er.",
        "guide": "I tillegg til det opplastede dokumentet kan du legge til supplerende opplysninger, f.eks. hvilken part du er, eller andre relevante omstendigheter som ikke fremgår av dokumentet.",
        "example_text": "",
        "placeholder": "Legg til supplerende opplysninger"
      },
      "argument_strengthener": {
        "title": "Styrk argumenter",
        "description": "Få en rask gjennomgang av argumentene dine. KAILA går gjennom argumentene dine, sammenholder dem med relevante rettskilder og finner argumentenes svakheter. Du får sterkere argumenter som er veldokumenterte med nøyaktige henvisninger til Karnovs innhold.",
        "guide": "I tillegg til det opplastede dokumentet kan du legge til supplerende opplysninger, f.eks. hvilken part du er, eller andre relevante omstendigheter som ikke fremgår av dokumentet.",
        "example_text": "",
        "placeholder": "Legg til supplerende opplysninger"
      },
      "weakness_finder": {
        "title": "Finn svakheter",
        "description": "Finn de stedene hvor argumentasjonen er svak eller mangelfull. KAILA går gjennom motpartens argumenter og kommer med motargumenter, foreslår mulige angrepsvinkler og hjelper med å formulere de beste argumentene med konkrete kildehenvisninger. Du får en strategi for å utnytte motpartens svakheter – dokumentert og klar til bruk.",
        "guide": "I tillegg til det opplastede dokumentet kan du legge til supplerende opplysninger, f.eks. hvilken part du er, eller andre relevante omstendigheter som ikke fremgår av dokumentet.",
        "example_text": "",
        "placeholder": "Legg til supplerende opplysninger"
      }
    }
  },
  "workspace_promo_banner": {
    "text": "Kom i gang med KAILA Flow",
    "link": "Les mer",
    "badge": "Nyhet"
  },
  "prompt_suggestions": {
    "kaila": {
      "title": "Finn svar til ditt juridiske informasjonsbehov",
      "description": "La deg inspirere av disse forslagene",
      "templates": [
        {
          "category": "book-section",
          "prompt": "Jeg trenger en oversikt over forskjellen på reglene om innsyn etter offentlighetsloven og forvaltningsloven. Jeg vil ha det som en tabell.",
          "sample": "Jeg trenger en oversikt over forskjellen på reglene om innsyn etter offentlighetsloven og forvaltningsloven."
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "Jeg trenger de beste argumentene for at klienten min kan få lavest mulig straff for å ha båret kniv på gaten. Klienten min ble stoppet av politiet i en rutinekontroll. Det var snakk om en kniv som normalt brukes i arbeid. Klienten min ble stoppet en tirsdag formiddag. Det skjedde i en sterkt trafikkert gate i sentrum av en by.",
          "sample": "Jeg trenger inspirasjon til argumenter som skal sikre klienten min lavest mulig straff."
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "Hvordan skal vesentlighetskravet i næringsleieloven § 13 tolkes?",
          "sample": "Jeg trenger en redegjørelse for vesentlighetskravet i næringsleieloven § 13."
        },
        {
          "category": "book-section",
          "prompt": "Jeg trenger et utkast til klage til en kommune i forbindelse med avslag på tilskudd til talepedagog til et barn. Barnet er tre år og har nedsatt hørsel, den ene forelderen er uten arbeid og den andre forelderen er ikke en del av barnets liv. Inkluder relevant lovgivning i utkastet.",
          "sample": "Jeg trenger et forslag til klage i forbindelse med avslag på tilskudd til talepedagog til et mindreårig barn."
        }
      ]
    },
    "kfc": {
      "title": "Finn svar på tvers av lovgivning og kommunens egne dokumenter",
      "description": "La deg inspirere av disse forslagene",
      "templates": [
        {
          "category": "book-section",
          "prompt": "Kan en mottaker av økonomisk sosialhjelp som oppfyller vilkårene for ferie først ta ut 14 dagers ferie med ytelse og deretter 14 dager uten ytelse?",
          "sample": "Kan en mottaker av økonomisk sosialhjelp som oppfyller vilkårene for ferie først ta ut 14 dagers ferie med ytelse og deretter 14 dager uten ytelse?"
        },
        {
          "category": "book-section",
          "prompt": "Er tøyeøvelser for å kunne opprettholde basale funksjoner som påkledning, bad osv. en ytelse etter helse- og omsorgstjenesteloven § 3-2 eller § 3-3?",
          "sample": "Er tøyeøvelser for å kunne opprettholde basale funksjoner som påkledning, bad osv. en ytelse etter helse- og omsorgstjenesteloven § 3-2 eller § 3-3?"
        },
        {
          "category": "book-section",
          "prompt": "Hvilke forhold skal kommunen være særlig oppmerksom på i sin avgjørelse om nedleggelse av en privat fellesvei?",
          "sample": "Hvilke forhold skal kommunen være særlig oppmerksom på i sin avgjørelse om nedleggelse av en privat fellesvei?"
        },
        {
          "category": "book-section",
          "prompt": "Hvilke krav til behandling av personopplysninger finnes ved manuell videreformidling av opplysninger om enkeltpersoner fra en kommune til en annen forvaltningsmyndighet?",
          "sample": "Hvilke krav til behandling av personopplysninger finnes ved manuell videreformidling av opplysninger om enkeltpersoner fra en kommune til en annen forvaltningsmyndighet?"
        }
      ]
    },
    "replay": {
      "title": "Spill av tidligere samtaler som er lagret lokalt på enheten din",
      "description": "Skriv indeksen til en tidligere samtale du vil spille av.",
      "templates": [
        {
          "category": "scale-unbalanced-flip",
          "prompt": "example",
          "sample": "Example"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "error",
          "sample": "Error"
        }
      ]
    },
    "mock": {
      "title": "Test rendering av ulike prompt",
      "description": "Test ulike use-case med disse eksemplene",
      "templates": [
        {
          "category": "scale-unbalanced-flip",
          "prompt": "test",
          "sample": "test"
        },
        {
          "category": "book-section",
          "prompt": "gfm",
          "sample": "Git flavoured markdown"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "invalid",
          "sample": "Invalid response"
        },
        {
          "category": "book-section",
          "prompt": "markdown",
          "sample": "markdown"
        },
        {
          "category": "siren-on",
          "prompt": "markdown-malformed",
          "sample": "Invalid & malformed markdown"
        },
        {
          "category": "siren-on",
          "prompt": "markdown-error",
          "sample": "Component that throws an uncaught exception"
        },
        {
          "category": "table",
          "prompt": "table",
          "sample": "table"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "details",
          "sample": "details"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "stressTest",
          "sample": "stress test"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "markdownAndInlineReferences",
          "sample": "Inline references after markdown elements"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "refsList",
          "sample": "Inline references in list"
        },
        {
          "category": "book-section",
          "prompt": "new-refsList",
          "sample": "New reference mdx format"
        }
      ] 
    }
  },
  "errors": {
    "footer": {
      "title": "Vi er klare til å hjelpe",
      "description": "Hvis du har støtt på problemer, kontakt kundeservice på {{telephone}} eller {{email}}",
      "email": "kundeservice@karnovgroup.com",
      "telephone": "33 74 07 00"
    },
    "auth": {
      "no_session": {
        "title": "",
        "subtitle": "",
        "description": ""
      },
      "default": {
        "title": "Vi kunne ikke logge deg inn",
        "subtitle": "",
        "description": "Det oppstod en feil under innlogging. Prøv igjen, eller kontakt kundesupport dersom problemet fortsetter."
      }
    }
  },
  "close_service_message_banner": "Lukk melding",
  "upload_modal": {
    "attachment_limit_exceeded_warning": "Du har valgt for mange dokumenter. Du kan legge ved opptil {{attachmentLimit}} dokumenter, avhengig av dokumentenes størrelse.",
    "close_modal_button_label": "Fullfør",
    "description": "Du kan legge ved opptil 10 dokumenter, avhengig av dokumentenes størrelse.",
    "done_button": "Fullfør",
    "file_browser": {
      "browse_files": "Bla gjennom",
      "description": "Støttede formater: .pdf, .docx",
      "header": "Klikk for å laste opp dokumenter"
    },
    "capacity_indicator": {
      "attachment_count": "{{count}}/{{limit}} dokumenter",
      "tooltip": "Hvert dokument tar opp en prosentandel av din totale opplastingsgrense, basert på antall ord – ikke filstørrelse. Lange dokumenter fyller derfor mer, slik at du kan nå 100 % før du har lastet opp 10 filer.",
      "used_capacity": "brukt plass"
    },
    "file_upload_button_tooltip": "Last opp og legg ved dokumenter",
    "header": "Last opp og legg ved dokumenter",
    "open_modal_button": "Last opp filer",
    "onboarding_tooltip": "Nyhet: Du kan nå laste opp opptil 10 dokumenter per melding.",
    "reinsurance_label": "Filene dine er kryptert",
    "reinsurance_tooltip": "Karnov Group beskytter konfidensialiteten til alle kundedata, inkludert brukerinndata, genererte data og dokumenter, ved hjelp av sterk kryptering som oppfyller gjeldende standarder."
  },
  "prompt_input_with_document_references": {
    "add_document_references_button": {
      "label": "Henvis til dokument",
      "tooltip": "Klik for at henvise til et dokument",
      "onboarding_tooltip": "Vi har gjort det enklere å henvise til dokumenter."
    }
  }, 
  "document_references_modal": {
    "description": "Ved at henvise til dokumenter fra Karnov kan du få et mere præcist svar",
    "close_modal_button_label": "Afslut",
    "document_references_count": "Valgte henvisninger ({{count}})",
    "done_button": "Afslut",
    "empty_state": {
      "header": "Inkluder en kilde i svaret",
      "description": "Du kan bruke denne funksjonen hvis du vil være sikker på at én eller flere kilder inkluderes i svaret fra Kaila."
    },
    "header": "Henvis til dokumenter fra Karnov",
    "remove_document_reference_button": "Fjern henvisning",
    "search": {
      "fetching_suggestions": "Henter dokumenter...",
      "input_label": "Søg efter et dokument fra Lovdata Pro Karnov",
      "input_placeholder": "Skriv dokumentets navn her",
      "error": {
        "description": "Forsøg at genindlæse siden",
        "title": "Noget gik galt"
      },
      "empty_search": {
        "description": "Skriv en gyldig titel eller reference, eller gå till Lovdata Pro Karnov og find dokumentet.",
        "kfc_disclaimer": "Kaila har allerede adgang til dine lokale dokumenter, så de behøver ikke at blive tagget.",
        "title": "Fandt ingen dokumenter"
      }
    }
  },
  "message_resources": {
    "remove_message_resource": {
      "attachment": "Fjern dokument",
      "document_reference": "Fjern referanse"
    },
    "open_modal": {
      "attachment": "Se dokumenter",
      "document_reference": "Se referanser"
    },
    "placeholder": {
      "label": {
        "attachment": "{{count}} vedlagte dokumenter",
        "document_reference": "{{count}} refererede dokumenter"
      },
      "tooltip": {
        "attachment": "Klikk for å se vedlagte dokumenter",
        "document_reference": "Klikk for å se refererte dokumenter"
      }
    }
  },
  "search": {
    "clear_input": "Ryd søgetekst",
    "placeholder": "Søk..."
  }
}
